import { Heading } from "@chakra-ui/react"
import darkLightPageStyles from "styles/darkLightStyles"
import Wrapper from "components/layout/wrapper"

export default function SinglesH1Heading({ title }) {
    return (
        <Wrapper id="pageHeader" pt={["20px", "30px", "40px"]}>
            <Heading
                as="h1"
                color={darkLightPageStyles.dark.pageTitleColor}
                fontWeight="600"
                dangerouslySetInnerHTML={{ __html: title }}
                pt={["0px", "0px", "0px"]}
                pb={3}
            />
        </Wrapper>
    )
}
